import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('fraud_detection_changes_made_after_approval'),
    subtitle: defineMessage('which_changes_made_in_n_isations_administrators'),
    optionCustomer: defineMessage('customer'),
    optionPayee: defineMessage('payee'),
    optionVendor: defineMessage('vendor'),
    optionTotalAmount: defineMessage('total_amount_more_than_companycurrencycode_change'),
    optionDate: defineMessage('date'),
    optionMemo: defineMessage('memo'),
    optionItem: defineMessage('item'),
    optionAccount: defineMessage('account'),
    optionExpenseCategory: defineMessage('expense_category'),
    optionLine: defineMessage('line_amounts'),
    optionBillPaymentLine: defineMessage('lines_bill_or_credit'),
};
